import React from "react";

const LoadingIcon = props => (
  <svg
    fill="currentColor"
    height="12"
    viewBox="0 0 12 12"
    width="12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 5.96859C12 2.93892 9.77778 0.43281 6.88889 0V1.59162C8.91667 2.00349 10.4444 3.81152 10.4444 5.96859C10.4444 8.43281 8.45139 10.4363 6 10.4363C3.54861 10.4363 1.55556 8.43281 1.55556 5.96859C1.55556 3.81152 3.08333 2.00349 5.11111 1.59162V0C2.22222 0.43281 0 2.93892 0 5.96859C0 9.29843 2.6875 12 6 12C9.3125 12 12 9.29843 12 5.96859Z" />
  </svg>
);

export default LoadingIcon;
